import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import OptionCards from 'components/common/OptionCards';

import { useTransportDictionaries } from '../dictionaries';
import styles from './styles.module.scss';

const infoIcon = new URL('../../../../../img/info-outline-white.svg', import.meta.url).href;

/** Данные в этих полях зависят от вида транспорта — о смене предупреждаем */
const DEPENDENT_FIELDS = [
  'transport_bodytype_ids',
  'transports_loading_types',
  'carrying_capacity',
  'length',
  'width',
  'height',
  'volume',
  'trailer_registration_number',
];

const KindStep = () => {
  const { t } = useTranslation();
  const { kinds } = useTransportDictionaries();
  const { values, setFieldValue } = useFormikContext<any>();

  const hasDependentData = DEPENDENT_FIELDS.some((field) => {
    const value = values[field];
    return Array.isArray(value) ? value.length > 0 : Boolean(value);
  });

  return (
    <div className={styles.step}>
      <p className={styles.stepTitle}>{t('transportFields.steps.kind_prompt')}</p>
      {values.transport_bodytype_additionals_id && hasDependentData && (
        <div className={styles.warning}>
          <span className={styles.warningIcon}>
            <img src={infoIcon} alt="" />
          </span>
          <span className={styles.warningText}>{t('transportFields.steps.change_warning')}</span>
        </div>
      )}
      <OptionCards
        options={kinds}
        columns={3}
        value={values.transport_bodytype_additionals_id || null}
        onChange={(value) => setFieldValue('transport_bodytype_additionals_id', String(value))}
      />
    </div>
  );
};

export default KindStep;
